import moment from 'moment';

const EDITOR_DATE_FORMAT = 'DD-MM-YYYY';
const DISPLAY_DATE_FORMAT = 'DD MMMM YYYY';

export default {
    filters: {
        formatDate(date){
            return moment(date).format(DISPLAY_DATE_FORMAT);
        }
    },
    
    methods: {
        parseFormattedDate(date){
            return moment(date, EDITOR_DATE_FORMAT).toDate();
        },
        formatDate(date){
            return moment(date).format(EDITOR_DATE_FORMAT);
        }
    }
}